import { appConfig } from '../config/appConfig';
import { apiClient } from './apiClient';
export type Dialogue = {
  pendingCommand?:{kind:string;target:string}|null;
  id: string; revision: number; completed: boolean; glance?: string; task?:{source:string;status:string;mode?:'question'|'listening'|'reading'|'interpreting';particleId:string|null;materialId:string|null}|null;
  messages: Array<{role: 'user' | 'assistant'; content: string; action?: string; hasImage?: boolean}>;
};
export type DialogueSummary = {
  id:string; subject:string; revision:number; title:string; summary?:string; lastMessage?:string; updatedAt:string; createdAt:string;
};
export async function dialogueRequest(path: string, body: Record<string, unknown>): Promise<Dialogue> {
  const token = await apiClient.getAccessToken();
  if (!token) throw new Error('请登录后开始复习');
  const res = await fetch(`${appConfig.keliagentBaseUrl}/api/v1/osr/dialogue${path}`, {
    method: 'POST', headers: {'Content-Type':'application/json', Authorization:`Bearer ${token}`},
    body: JSON.stringify(body), signal: AbortSignal.timeout(75000),
  });
  const data = await res.json().catch(()=>null);
  if (!res.ok) throw new Error(data?.message || `对话暂不可用（${res.status}）`);
  if (!data?.id || !Array.isArray(data.messages)) throw new Error('对话响应异常，请重试');
  return data;
}
export async function listDialogues(subject: string): Promise<DialogueSummary[]> {
  const token = await apiClient.getAccessToken();
  if (!token) throw new Error('请登录后查看历史对话');
  const query = new URLSearchParams({ subject });
  const res = await fetch(`${appConfig.keliagentBaseUrl}/api/v1/osr/dialogue?${query.toString()}`, {
    headers: {Authorization:`Bearer ${token}`}, signal: AbortSignal.timeout(20000),
  });
  const data = await res.json().catch(()=>null);
  if (!res.ok) throw new Error(data?.message || `历史对话暂不可用（${res.status}）`);
  if(!Array.isArray(data?.items))throw new Error('历史对话响应异常，请稍后重试');
  return data.items;
}
export async function getDialogue(id: string): Promise<Dialogue> {
  const token = await apiClient.getAccessToken();
  if (!token) throw new Error('请登录后查看历史对话');
  const res = await fetch(`${appConfig.keliagentBaseUrl}/api/v1/osr/dialogue/${encodeURIComponent(id)}`, {
    headers: {Authorization:`Bearer ${token}`}, signal: AbortSignal.timeout(20000),
  });
  const data = await res.json().catch(()=>null);
  if (!res.ok) throw new Error(data?.message || `历史对话暂不可用（${res.status}）`);
  if (!data?.id || !Array.isArray(data.messages)) throw new Error('历史对话响应异常');
  return data;
}
